<app-authorized-guard
  [authorized]="!unauthorized"
  message="You are not authorized to edit this Organization"
>
  <app-loading-guard [loading]="loading">
    <app-organization-form
      *ngIf="item$ | async as item"
      [pending]="pending"
      (submit)="editEntity()"
      (cancel)="cancelEdit()"
    ></app-organization-form>
  </app-loading-guard>
</app-authorized-guard>
